'use client';

import { useRef } from 'react';

interface UseVerticalSwipeOptions {
  onSwipeUp?: () => void;
  onSwipeDown?: () => void;
  threshold: number;
  requireAtTop?: { current: HTMLElement | null };
}

export function useVerticalSwipe({ onSwipeUp, onSwipeDown, threshold, requireAtTop }: UseVerticalSwipeOptions) {
  const startXRef = useRef(0);
  const startYRef = useRef(0);
  const startedAtTopRef = useRef(true);

  const onTouchStart = (e: React.TouchEvent) => {
    startXRef.current = e.touches[0].clientX;
    startYRef.current = e.touches[0].clientY;
    if (requireAtTop) {
      startedAtTopRef.current = (requireAtTop.current?.scrollTop ?? 0) <= 0;
    }
  };

  const onTouchEnd = (e: React.TouchEvent) => {
    const touch = e.changedTouches[0];
    const dx = touch.clientX - startXRef.current;
    const dy = touch.clientY - startYRef.current;

    if (Math.abs(dy) <= Math.abs(dx) || Math.abs(dy) <= threshold) return;

    if (dy < 0) {
      onSwipeUp?.();
      return;
    }

    if (requireAtTop && !startedAtTopRef.current) return;
    onSwipeDown?.();
  };

  return { onTouchStart, onTouchEnd };
}
